import { z } from "zod";
import { ApplicationStatus } from "./ApplicationStatus";
import { ApplicationType } from "./ApplicationType";
import { BusinessDetailsModelSchema } from "./BusinessDetailsModel";
import { LoyaltyDetailsModelSchema } from "./LoyaltyDetailsModel";
import { CreditCheckDetailsModelSchema } from "./CreditCheckDetailsModel";
import { FinalDetailsModelSchema } from "./FinalDetailsModes";
import { CardDetailsModelSchema } from "./CardDetailsModel";
import { CallbackDetailsModelSchema } from "./CallbackDetailsModel";
import { IfcsDetailsModelSchema } from "./IfcsDetailsModel";

export const ApplicationModelSchema = z.object({
  id: z.number(),
  externalId: z.string().nullable(),
  fullName: z.string().nullable(),
  email: z.string().nullable(),
  receiveCorrespondence: z.boolean(),
  status: z.nativeEnum(ApplicationStatus),
  type: z.nativeEnum(ApplicationType),
  businessDetails: BusinessDetailsModelSchema.nullable(),
  loyaltyDetails: LoyaltyDetailsModelSchema.nullable(),
  creditDetails: CreditCheckDetailsModelSchema.nullable(),
  finalDetails: FinalDetailsModelSchema.nullable(),
  ifcsDetails: IfcsDetailsModelSchema.nullable(),
  cardDetails: CardDetailsModelSchema.nullable(),
  callbackDetails: CallbackDetailsModelSchema.nullable(),

  submittedDate: z.coerce.date().nullable(),
  cancellationReason: z.string().nullable(),
  jdeAccountNumber: z.string().nullable(),
  ifcsAccountNumber: z.string().nullable(),
  creditOutcome: z.string().nullable(),
  creditOutcomeReason: z.string().nullable(),
  creditDecisionChangeReason: z.string().nullable(),
  creditLimit: z.number().nullable(),
});

export type ApplicationModel = z.infer<typeof ApplicationModelSchema>;
